export default __webpack_public_path__ + "static/media/MP0070.50d67e80.jpg";